
<template>
  <!--栏目管理-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="circle_category_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'column',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '栏目名', options: [], inputType: 'input' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        create_date: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['neighbour:column:add'] },
        { text: '删除', icon: 'close', disabled: true, key: 'batchDel' }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['neighbour:column:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name), permi: ['neighbour:column:edit'] },
        { text: '顶置', handle: record => this.topping(record), permi: ['neighbour:column:top'] }
      ],
      columns: [
        { title: '栏目名', dataIndex: 'title', align: 'left', width: '' },
        { title: '类型', dataIndex: 'type_txt', align: 'left', width: '' },
        { title: '动态数', dataIndex: 'circle_count', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/circle/columns',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addColumn',
        addTitle: '新增栏目',
        editTitle: '修改栏目'
      },
      deleteParam: {
        url: '/circle/columns',
        param: {pk_key: 'circle_category_id', pk_val: ''},
        title: '栏目名',
        key: 'title'
      }
    };
  },
  mounted () {
  },
  methods: {
    /** 顶置该栏目名 */
    topping (row) {
      this._post({
        url: `/circle/columns/${row.circle_category_id}/top`,
        params: {}
      }).then(({data}) => {
        this.$message.success('顶置成功');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
